import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import Plural from 'components/utils/Formatters/Plural'
import Image from 'components/Common/Image'
import Divider from 'components/Luxkit/Divider'
import { ImageParams } from 'components/Common/ResponsiveImage'
import LineChairWithAirplaneIcon from 'components/Luxkit/Icons/line/LineChairWithAirplaneIcon'

const heroParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

const sydneyImage: App.Image = {
  id: 'kzm3koehce1bnfgllw6',
  title: 'Free airport lounge passes',
}

const melbourneImage: App.Image = {
  id: '7az56i6w48107shjjo8',
  title: 'Free airport lounge passes',
}

const brisbaneImage: App.Image = {
  id: 'm6uwh8r4zlr5yzw9b28',
  title: 'Free airport lounge passes',
}

const perthImage: App.Image = {
  id: 'isf0ct3glbky1z98nka',
  title: 'Free airport lounge passes',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  numberOfBenefitRemaining: number
}

function LandingPageLoyaltyLoungePassBenefitsModal(props: Props) {
  const { image, tier, numberOfBenefitRemaining } = props
  return (
    <ModalBase size="L">
      <ModalHeader title="Free airport lounge passes" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={heroParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            {!!numberOfBenefitRemaining && <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={<BodyText variant="small">{getLoyaltyTierDisplayName(tier)} Member Benefit</BodyText>}
              icon={<LineChairWithAirplaneIcon />}
            >
              <BodyText variant="medium">You have {numberOfBenefitRemaining > 1 ? `${numberOfBenefitRemaining}x` : 'a'} free airport lounge <Plural count={numberOfBenefitRemaining} singular="pass" plural="passes" /> available</BodyText>
            </LoyaltyTierCallOutBanner>}
            <BodyText variant="large">
              Kick off your trip in comfort with complimentary access to select airport lounges across Australia. Recharge with a drink, a bite to eat, and space to relax before your flight.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                When booking an overseas hotel, you will get the option to add the complimentary lounge passes during the checkout process before you book.
              </BodyText>
            </VerticalSpacer>
            <Heading variant="heading4">Eligible airport lounges</Heading>
            <VerticalSpacer gap={12}>
              <Group direction="horizontal" gap={20} verticalAlign="center">
                <Image
                  image={sydneyImage}
                  aspectRatio="5:3"
                  width="140px"
                />
                <Heading variant="heading6">Sydney International Airport (SYD)</Heading>
              </Group>
              <Divider kind="primary" />
              <Group direction="horizontal" gap={20} verticalAlign="center">
                <Image
                  image={melbourneImage}
                  aspectRatio="5:3"
                  width="140px"
                />
                <Heading variant="heading6">Melbourne International Airport (MEL)</Heading>
              </Group>
              <Divider kind="primary" />
              <Group direction="horizontal" gap={20} verticalAlign="center">
                <Image
                  image={perthImage}
                  aspectRatio="5:3"
                  width="140px"
                />
                <Heading variant="heading6">Perth International Airport (PER)</Heading>
              </Group>
              <Divider kind="primary" />
              <Group direction="horizontal" gap={20} verticalAlign="center">
                <Image
                  image={brisbaneImage}
                  aspectRatio="5:3"
                  width="140px"
                />
                <Heading variant="heading6">Brisbane International Airport (BNE)</Heading>
              </Group>
              <Divider kind="primary" />
              <BodyText variant="small">
                Lounge access is available exclusively at the above airports.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyLoungePassBenefitsModal
